import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";

const StyledDropdown = styled.div`
  width: 100%;
  .dropdown-content {
    display: ${(props) => (props.isOpen ? "block" : "none")};
    position: absolute;
    margin: 16px;
    left: 50%;
    transform: translate(-50%);
    z-index: 1;
    background-color: ${nota.color.neutral.white};
  }

  .forcePosition {
    position: fixed;
  }
`;

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: this.props.isOpen ? true : false,
      isVisible: true,
    };

    this.mainRef = React.createRef();
    this.contentRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
    window.addEventListener("scroll", this.onScroll, true);
    window.addEventListener("resize", this.onResize, true);

    if (this.props.forcePosition) {
      const lazyLoad = (target) => {
        const io = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting !== this.state.isOpen && this.state.isOpen) {
              this.setState({ isOpen: false });
            }
          });
        });

        io.observe(target);
      };

      lazyLoad(this.mainRef.current);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen !== this.state.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }

    if (prevState.isOpen !== this.state.isOpen && this.props.onChangeToggle) {
      this.props.onChangeToggle(this.state.isOpen);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }

  handleOutsideClick = (e) => {
    if (this.props.onClickOutsideClose && !this.node.contains(e.target)) this.setState({ isOpen: false });
  };

  toggleOpen = () => {
    if (!this.props.preventToggleOpen) this.setState({ isOpen: !this.state.isOpen });
  };

  getContentStyle = () => {
    if (this.props.forcePosition && this.mainRef.current != null && this.contentRef.current != null) {
      let mainRect = this.mainRef.current.getBoundingClientRect();
      let bodyRect = document.body.getBoundingClientRect();
      let top = mainRect.y + mainRect.height;
      let rigth = bodyRect.width - mainRect.x;
      if (this.props.offsetTop) top += this.props.offsetTop;
      if (this.props.offsetRigth) rigth += this.props.offsetRigth;
      return {
        top: `${top}px`,
        right: `${rigth}px`,
      };
    }
    return {};
  };

  onScroll = () => {
    if (this.props.forcePosition) {
      this.forceUpdate();
    }
  };

  onResize = () => {
    if (this.props.forcePosition) {
      this.forceUpdate();
    }
  };

  onMouseEnterHandler = () => {
    if (!this.props.preventToggleOpen && this.props.enableHover) this.setState({ isOpen: true });
  };

  onMouseLeaveHandler = () => {
    if (!this.props.preventToggleOpen && this.props.enableHover) this.setState({ isOpen: false });
  };

  render() {
    return (
      <StyledDropdown className="dropdown" ref={(node) => (this.node = node)} isOpen={this.state.isOpen}>
        <NanoFlex ref={this.mainRef} onClick={this.toggleOpen} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
          {this.props.main}
        </NanoFlex>
        <div ref={this.contentRef} style={this.getContentStyle()} className={`dropdown-content ${this.props.forcePosition ? "forcePosition" : ""}`}>
          {this.props.content}
        </div>
      </StyledDropdown>
    );
  }
}

export default Dropdown;

// --- // Documentation // --- //
/*
import Dropdown from './../Nano/Dropdown.js';

<Dropdown
    main={
        <NanoFlex>
            <Type.h3><b>Date Range Picker</b></Type.h3>
        </NanoFlex>}
    content={
        <NanoFlex>
            <DateRangePicker/>
        </NanoFlex>}
    onChangeToggle={(isOpen) => this.setState({ isOpenDropdown: isOpen })}
/>
*/
